/**
 * 右键菜单
 * created by lei lei
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign'

import './rightClickMenu.scss'
import _ from 'lodash'

export default class RightClickMenu extends Component {
    static propTypes = {
        style: PropTypes.object,
        onClickVideoAudioSpeedBtn: PropTypes.func,
        menu:PropTypes.array.isRequired,
    };

    static defaultProps = {
        style: {},
        onClickVideoAudioSpeedBtn: _.noop,
    };

    state = {
        visible: false,
        left: 0,
        top: 0,
    };

    componentDidMount() {
        // 添加右键点击、点击事件监听
       // document.addEventListener('contextmenu', this.handleContextMenu)
        document.addEventListener('click', this.handleClick)
    }

    componentWillUnmount() {
        // 移除事件监听
      //  document.removeEventListener('contextmenu', this.handleContextMenu)
        document.removeEventListener('click', this.handleClick)
    }

    // 右键菜单事件
    handleContextMenu = (event) => {
        event.preventDefault();

        this.setState({visible: true});

        // clientX/Y 获取到的是触发点相对于浏览器可视区域左上角距离
        const clickX = event.clientX;
        const clickY = event.clientY;
        // window.innerWidth/innerHeight 获取的是当前浏览器窗口的视口宽度/高度
        const screenW = window.innerWidth;
        const screenH = window.innerHeight;
        // 获取自定义菜单的宽度/高度
        const rootW = this.root.offsetWidth;
        const rootH = this.root.offsetHeight;
        console.log(rootW, rootH)

        // right为true，说明鼠标点击的位置到浏览器的右边界的宽度可以放下菜单。否则，菜单放到左边。
        // bottom为true，说明鼠标点击位置到浏览器的下边界的高度可以放下菜单。否则，菜单放到上边。
        const right = (screenW - clickX) > rootW;
        const left = !right;
        const bottom = (screenH - clickY) > rootH;
        const top = !bottom;

        if (right) {
            this.root.style.left = `${clickX}px`
        }

        if (left) {
            this.root.style.left = `${clickX - rootW}px`
        }

        if (bottom) {
            this.root.style.top = `${clickY}px`
        }
        if (top) {
            this.root.style.top = `${clickY - rootH}px`
        }
    };

    showMenu(e) {
        e.preventDefault();
        // clientX/Y 获取到的是触发点相对于浏览器可视区域左上角距离
        const clickX = e.clientX;
        const clickY = e.clientY;
        // window.innerWidth/innerHeight 获取的是当前浏览器窗口的视口宽度/高度
        const screenW = window.innerWidth;
        const screenH = window.innerHeight;

        // 获取自定义菜单的宽度/高度
        const rootW = 160;
        const rootH = this.props.menu.length*24;

        // right为true，说明鼠标点击的位置到浏览器的右边界的宽度可以放下菜单。否则，菜单放到左边。
        // bottom为true，说明鼠标点击位置到浏览器的下边界的高度可以放下菜单。否则，菜单放到上边。
        const right = (screenW - clickX) > rootW;
        const left = !right;
        const bottom = (screenH - clickY) > rootH;
        const top = !bottom;
        if (right) {
            //this.root.style.left = `${clickX}px`
            this.state.left = clickX;
        }
        if (left) {
            //this.root.style.left = `${clickX - rootW}px`
            this.state.left = clickX - rootW;
        }
        if (bottom) {
            //this.root.style.top = `${clickY}px`
            this.state.top = clickY;
        }
        if (top) {
            //this.root.style.top = `${clickY - rootH}px`
            this.state.top = clickY - rootH;
        }
        this.setState({visible: true});
    }

    // 鼠标单击事件，当鼠标在任何地方单击时，设置菜单不显示
    handleClick = () => {
        const {visible} = this.state;
        if (visible) {
            this.setState({visible: false})
        }
    };


    render() {
        let currentStyle = {top: this.state.top, right: this.state.left};
        const wrapStyles = assign({}, this.props.style, {top: this.state.top, left: this.state.left});
        const {visible} = this.state;

        return (
            visible&& (
                <div id={'rightMenu'} ref={(ref) => {
                    this.root = ref
                }} className="contextMenu-wrap" style={wrapStyles}>
                    {this.props.menu.map((item,index)=>{
                        return(
                            <div className="contextMenu-option" style={{color:item.color?item.color:'black'}} key={index} onClick={()=>{item.onClick&&item.onClick()}}>{item.title}</div>
                        )
                    })}
                </div>
            )
        )
    }

}